import { Check, X } from "lucide-react";
import { SectionHeader, BodyText } from "@/components/ui/typography";

const comparisons = [
  {
    aspect: "Feedback Frequency",
    traditional: "Annual engagement survey",
    sendfeedback: "Continuous pulse on culture health",
  },
  {
    aspect: "True Anonymity",
    traditional: "\"Anonymous\" with metadata tracking",
    sendfeedback: "Legal-grade anonymity—even HR can't identify",
  },
  {
    aspect: "Time to Insights",
    traditional: "Weeks of manual analysis",
    sendfeedback: "Instant AI-powered analysis",
  },
  {
    aspect: "Board/C-Suite Reporting",
    traditional: "Manual slide deck creation",
    sendfeedback: "Auto-generated executive dashboards",
  },
  {
    aspect: "Exit Interview Insights",
    traditional: "Biased post-departure feedback",
    sendfeedback: "Honest feedback before they quit",
  },
  {
    aspect: "HR Team Workload",
    traditional: "Weeks analyzing spreadsheets",
    sendfeedback: "AI does analysis—HR takes action",
  },
  {
    aspect: "Compliance Documentation",
    traditional: "DIY documentation",
    sendfeedback: "Audit-ready anonymity architecture",
  },
  {
    aspect: "Setup Time",
    traditional: "Weeks with consultants",
    sendfeedback: "2 minutes, no IT needed",
  },
];

export const ComparisonTable = () => {
  return (
    <section className="bg-muted/30 py-8 sm:py-12 md:py-16">
      <div className="container mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto space-y-6 sm:space-y-8 md:space-y-12">
          <div className="text-center space-y-2 max-w-3xl mx-auto">
            <SectionHeader className="text-foreground px-2">
              Why HR Leaders Choose SendFeedback
            </SectionHeader>
            <BodyText className="text-muted-foreground px-2">
              Traditional surveys weren't built for modern HR challenges
            </BodyText>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-hidden rounded-xl border border-border bg-card">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border bg-muted/50">
                  <th className="text-left p-4 font-semibold text-foreground">
                    Feature
                  </th>
                  <th className="text-left p-4 font-semibold text-muted-foreground">
                    Traditional Surveys
                  </th>
                  <th className="text-left p-4 font-semibold text-primary bg-primary/5">
                    SendFeedback
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((row, index) => (
                  <tr
                    key={row.aspect}
                    className={index !== comparisons.length - 1 ? "border-b border-border" : ""}
                  >
                    <td className="p-4 font-medium text-foreground">
                      {row.aspect}
                    </td>
                    <td className="p-4 text-muted-foreground">
                      <div className="flex items-start gap-2">
                        <X className="h-5 w-5 text-destructive flex-shrink-0 mt-0.5" />
                        <span>{row.traditional}</span>
                      </div>
                    </td>
                    <td className="p-4 bg-primary/5">
                      <div className="flex items-start gap-2">
                        <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-foreground font-medium">
                          {row.sendfeedback}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards - Optimized 2-column grid */}
          <div className="md:hidden grid grid-cols-1 xs:grid-cols-2 gap-2.5 sm:gap-3">
            {comparisons.map((row) => (
              <div
                key={row.aspect}
                className="rounded-lg border border-border bg-card p-3 space-y-2"
              >
                <h4 className="font-semibold text-foreground text-xs leading-tight line-clamp-2">{row.aspect}</h4>
                <div className="space-y-1.5">
                  <div className="flex items-start gap-1.5">
                    <X className="h-3.5 w-3.5 text-destructive flex-shrink-0 mt-0.5" />
                    <span className="text-muted-foreground text-xs leading-tight line-clamp-2">
                      {row.traditional}
                    </span>
                  </div>
                  <div className="flex items-start gap-1.5 bg-primary/5 -mx-3 px-3 py-1.5 rounded-b-lg">
                    <Check className="h-3.5 w-3.5 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-foreground font-medium text-xs leading-tight line-clamp-2">
                      {row.sendfeedback}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
